<!--  -->
<template>
  <el-form ref="ruleForm" :model="ruleForm" :rules="rules" label-width="130px" class="demo-ruleForm">
    <el-form-item label="活动名称" prop="title">
      <el-input v-model="ruleForm.title" v-model.trim="ruleForm.title" style="width:400px" @input="ruleForm.title = ruleForm.title.replace(reg, '')" />
    </el-form-item>
    <el-form-item label="活动标题" prop="copywriting">
      <el-input v-model="ruleForm.copywriting" style="width:400px" placeholder="建议标题不超过12字符，超过前端展示效果差" />
    </el-form-item>
    <el-form-item label="活动金额" prop="resource">
      <el-radio-group v-model="ruleForm.resource" @change="activemoney">
        <el-radio v-for="element,index in list" :key="index" style="margin-bottom:10px" :label="element.value">{{ element.description }}</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="期限选择">
      <el-select v-model="time_type" placeholder="请选择">
        <el-option
          v-for="item in timeoptions"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        />
      </el-select>
    </el-form-item>
    <el-form-item v-if="time_type === 2" label="固定天数" prop="appoint_day">
      <el-input v-model="ruleForm.appoint_day" style="width:300px" placeholder="请输入固定天数" type="number" :onkeyup="ruleForm.appoint_day = ruleForm.appoint_day.replace(/[^A-z0-9]/, '')" />
    </el-form-item>
    <el-form-item v-if="time_type === 1" label="活动时间" prop="timearr">
      <el-date-picker
        v-model="ruleForm.timearr"
        format="yyyy-MM-dd HH:mm:ss"
        value-format="yyyy-MM-dd HH:mm:ss"
        :default-time="['00:00:00', '23:59:59']"
        type="datetimerange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        style="width:410px"
        :picker-options="pickerOptions"
        :clearable="false"
        @change="datavalue"
      />
    </el-form-item>
    <el-form-item label="限购次数" prop="buy_times">
      <el-radio-group v-model="ruleForm.buy_times" @change="activemoney">
        <el-radio v-for="element,index in options" :key="index" :label="element.value">{{ element.label }}</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="活动弹窗" prop="has_popup">
      <el-radio-group v-model="ruleForm.has_popup" @change="activepopup">
        <el-radio v-for="element,index in optionsr" :key="index" :label="element.value">{{ element.label }}</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item v-if="ruleForm.has_popup == 1" label="展示位置" prop="popup_display_area">
      <el-checkbox-group
        v-model="ruleForm.popup_display_area"
      >
        <el-checkbox
          v-for="item in themarr"
          :key="item.description"
          :label="item.value"
        >
          {{ item.description }}
        </el-checkbox>
      </el-checkbox-group>
    </el-form-item>
    <el-form-item label="弹窗接收用户" prop="popup_audience">
      <el-radio-group v-model="ruleForm.popup_audience">
        <el-radio v-for="element,index in popuserarr" :key="index" :label="element.value">{{ element.label }}</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="阅读页banner" prop="has_banner">
      <el-radio-group v-model="ruleForm.has_banner" @change="banerpopup">
        <el-radio v-for="element,index in readingarr" :key="index" :label="element.value">{{ element.label }}</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item v-if="ruleForm.has_banner == 1" label="banner接收用户" prop="banner_audience">
      <el-radio-group v-model="ruleForm.banner_audience">
        <el-radio v-for="element,index in bannerarr" :key="index" :label="element.value">{{ element.label }}</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="接受粉丝" prop="user_type">
      <el-radio-group v-model="ruleForm.user_type">
        <el-radio :label="0">全量用户</el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item label="选择模板">
      <el-tag v-if="ruleForm.tpl_id !== null" size="medium" style="height:35px;line-height:35px;margin-right:10px;padding: 0 23px;">{{ tpl_name }}</el-tag>
      <el-button type="primary" @click="choosetheme"> 选择活动主题 </el-button>
      <div>
        <el-radio-group
          v-model="dataType"
          class="chooseType"
        >
          <el-radio
            :label="1"
            @click.native.prevent="clickitemdataType(1)"
          >增币活动</el-radio>
        </el-radio-group>
      </div>

    </el-form-item>
    <el-form-item>
      <el-button style="margin-top:10px" type="primary" @click="submitForm('ruleForm')">立即创建</el-button>
    </el-form-item>
    <el-dialog
      title="活动主题选择"
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :modal-append-to-body="false"
      :append-to-body="true"
    >
      <themedialog ref="themeview" @close="close" />
    </el-dialog>
  </el-form>
</template>

<script>
import { readingservice, acawraccountlist } from '@/api/sourceMaterial.js'
import themedialog from './themedialog.vue'
export default {
  components: {
    themedialog
  },
  props: {
    platformid: {
      type: Number,
      default: null
    }
  },
  data() {
    var checkAger = (rule, value, callback) => {
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.appoint_day.length > 3) {
        callback(new Error('不能超过3位'))
      } else {
        callback()
      }
    }
    var checkAge = (rule, value, callback) => {
      console.log(this.ruleForm.timearr[0])
      console.log(this.ruleForm.timearr[1])
      // eslint-disable-next-line eqeqeq
      if (this.ruleForm.timearr[0] == this.ruleForm.timearr[1]) {
        callback(new Error('不能选择相同的时间'))
      } else {
        callback()
      }
    }
    return {
      // eslint-disable-next-line no-misleading-character-class
      reg: /[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF][\u200D|\uFE0F]|[\uD83C|\uD83D|\uD83E][\uDC00-\uDFFF]|[0-9|*|#]\uFE0F\u20E3|[0-9|#]\u20E3|[\u203C-\u3299]\uFE0F\u200D|[\u203C-\u3299]\uFE0F|[\u2122-\u2B55]|\u303D|[\A9|\AE]\u3030|\uA9|\uAE|\u3030/gi,
      ruleForm: {
        title: '',
        copywriting: '',
        resource: null,
        buy_times: 1,
        has_popup: 0,
        popup_display_area: [],
        timearr: [],
        popup_audience: 0,
        has_banner: 0,
        banner_audience: 0,
        user_type: 0,
        tpl_id: null,
        appoint_day: ''
      },
      dataType: '',
      tpl_name: '',
      stime: '',
      etime: '',
      dialogVisible: false,
      theme: [],
      pickerOptions: { // 禁用当前日期之前的日期
        disabledDate(time) {
          // Date.now()是javascript中的内置函数，它返回自1970年1月1日00:00:00 UTC以来经过的毫秒数。
          return time.getTime() < Date.now() - 8.64e7
        }
      },
      rules: {
        title: [
          { required: true, message: '请输入活动名称', trigger: 'blur' }
        ],
        copywriting: [
          { required: true, message: '请输入活动标题', trigger: 'blur' }
        ],
        resource: [
          { required: true, message: '请选择活动金额', trigger: 'change' }
        ],
        timearr: [
          { type: 'array', required: true, message: '请选择时间', trigger: 'change' },
          { validator: checkAge, trigger: 'change' }
        ],
        appoint_day: [
          { required: true, message: '请输入固定天数', trigger: 'change' },
          { validator: checkAger, trigger: 'change' }
        ],
        buy_times: [
          { required: true, message: '请选择限购次数', trigger: 'change' }
        ],
        has_popup: [
          { required: true, message: '请选择活动弹窗', trigger: 'change' }
        ],
        popup_display_area: [
          { type: 'array', required: true, message: '请至少选择一个展示位置', trigger: 'change' }
        ],
        popup_audience: [
          { required: true, message: '请选择弹窗接收用户', trigger: 'change' }
        ],
        has_banner: [
          { required: true, message: '请选择阅读页banner', trigger: 'change' }
        ],
        banner_audience: [
          { required: true, message: '请选择阅读页banner', trigger: 'change' }
        ],
        user_type: [
          { required: true, message: '请选择接受粉丝', trigger: 'change' }
        ]
      },
      timeoptions: [
        {
          value: 1,
          label: '指定期限'
        }, {
          value: 2,
          label: '固定天数'
        }
      ],
      time_type: 2,
      options: [{
        value: 1,
        label: '1次'
      }, {
        value: 2,
        label: '2次'
      }, {
        value: 3,
        label: '3次'
      }],
      optionsr: [{
        value: 0,
        label: '关闭'
      }, {
        value: 1,
        label: '开启'
      }],
      list: [],
      themarr: [
        {
          value: 'index_page',
          description: '首页 '
        },
        {
          value: 'boy_page',
          description: '男生'
        },
        {
          value: 'girl_page',
          description: '女生'
        },
        {
          value: 'bookshelf_page',
          description: '书架'
        },
        {
          value: 'recent_read_page',
          description: '最近阅读页'
        },
        {
          value: 'home_page',
          description: '我的个人中心'
        },
        {
          value: 'read_page',
          description: '书籍阅读页'
        }
      ],
      popuserarr: [{
        value: 0,
        label: '全部'
      }, {
        value: 1,
        label: '已经充值用户'
      }, {
        value: 2,
        label: '未充值用户'
      }],
      readingarr: [
        {
          value: 0,
          label: '关闭'
        },
        {
          value: 1,
          label: '开启'
        }
      ],
      bannerarr: [
        {
          value: 0,
          label: '全部'
        }, {
          value: 1,
          label: '已经充值用户'
        }, {
          value: 2,
          label: '未充值用户'
        }
      ],
      status: null
    }
  },
  created() {
    this.getlistr()
  },
  mounted() {

  },
  methods: {
    async getlistr() {
      const data = await acawraccountlist({
        platformId: this.platformid,
        activityType: 4
      })
      this.list = data.data.programme
      this.theme = data.data.theme
      this.ruleForm.tpl_id = data.data.theme[0].value
      this.tpl_name = data.data.theme[0].description
      console.log('data', data)
    },
    datavalue(val) {
      console.log('val')
      this.stime = val[0]
      this.etime = val[1]
    },

    activemoney(val) {
      console.log('val', val)
    },
    activepopup(val) {
      console.log('val', val)
      // eslint-disable-next-line eqeqeq
      if (val == 0) {
        this.ruleForm.popup_display_area = []
      }
    },
    banerpopup(val) {
      console.log('val', val)
      // eslint-disable-next-line eqeqeq
      if (val == 0) {
        this.ruleForm.banner_audience = 0
      }
    },
    choosetheme() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.$refs.themeview.send(this.theme, 1)
      })
    },
    close(item) {
      this.dialogVisible = false
      this.ruleForm.tpl_id = item.value
      this.tpl_name = item.description
      console.log('item', item)
    },
    clickitemdataType(e) { // e为radio的label值
      e === this.dataType ? this.dataType = '' : this.dataType = e
    },
    submitForm(formName) {
      console.log(this.ruleForm.popup_display_area)
      //  ['pop_range' + '[' + this.reding + ']']: this.reding
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const par = {}
          if (this.time_type === 1) {
            par.time_type = this.time_type
            par.start_time = this.stime
            par.end_time = this.etime
          } else {
            par.time_type = this.time_type
            par.appoint_day = Number(this.ruleForm.appoint_day)
          }
          this.status = null
          // eslint-disable-next-line eqeqeq
          if (this.dataType == '') {
            // this.status = null
            readingservice({
              activity_info: {
                display: 'json',
                title: this.ruleForm.title,
                [`pid_1`]: this.ruleForm.resource,
                pid_2: '',
                // stime: this.stime / 1000,
                // etime: this.etime / 1000,
                buy_times: this.ruleForm.buy_times,
                copywriting: this.ruleForm.copywriting,
                has_popup: this.ruleForm.has_popup,
                popup_audience: this.ruleForm.popup_audience,
                popup_display_area: this.ruleForm.popup_display_area.toString(),
                has_banner: this.ruleForm.has_popup,
                banner_audience: this.ruleForm.banner_audience,
                user_type: this.ruleForm.user_type
              },
              platform_id: this.platformid,
              activity_type: 4,
              ...par
            }).then((res) => {
              this.$message({
                type: 'success',
                message: '添加成功!'
              })
              this.$emit('close')
            })
          } else {
            // this.status = this.ruleForm.tpl_id
            readingservice({
              activity_info: {
                display: 'json',
                title: this.ruleForm.title,
                [`pid_1`]: this.ruleForm.resource,
                pid_2: '',
                // stime: this.stime / 1000,
                // etime: this.etime / 1000,
                buy_times: this.ruleForm.buy_times,
                copywriting: this.ruleForm.copywriting,
                tpl_id: this.ruleForm.tpl_id,
                has_popup: this.ruleForm.has_popup,
                popup_audience: this.ruleForm.popup_audience,
                popup_display_area: this.ruleForm.popup_display_area.toString(),
                has_banner: this.ruleForm.has_popup,
                banner_audience: this.ruleForm.banner_audience,
                user_type: this.ruleForm.user_type
              },
              platform_id: this.platformid,
              activity_type: 4,
              ...par
            }).then((res) => {
              this.$message({
                type: 'success',
                message: '添加成功!'
              })
              this.$emit('close')
            })
          }
        } else {
          console.log('error submit!!')
          return false
        }
      })
    }
  }
}
</script>
<style scoped>
/* @import url(); 引入css类 */

</style>
